import {NgModule} from "@angular/core";
import {IntWrapDropdownComponent} from "./int-wrap-dropdown.component";
import {CommonModule} from "@angular/common";

@NgModule({
  imports: [CommonModule],
  declarations: [IntWrapDropdownComponent],
  exports: [IntWrapDropdownComponent]
})
export class IntWrapDropdownModule {}
